import React from 'react'
import styles from './AlertBanner.module.scss'

type Variant = 'success' | 'error' | 'warning' | 'info'

interface AlertBannerProps {
  children: React.ReactNode
  variant?: Variant
  className?: never
}

const variantMap: Record<Variant, string> = {
  success: styles.success, error: styles.error, warning: styles.warning, info: styles.info,
}

export const AlertBanner: React.FC<AlertBannerProps> = ({ children, variant = 'info' }) => (
  <div className={[styles.banner, variantMap[variant]].join(' ')}>{children}</div>
)
